.form-container {
    height: 70px;
}

.info {
    font-size: var(--font-normal);
    padding-bottom: 16px;
}
